function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-4 -1.8)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(9.336 7.136)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M26.439,33.895H18.625a.578.578,0,0,1-.508-.254.887.887,0,0,1-.191-.572,7.013,7.013,0,0,0-.826-3.875,5.954,5.954,0,0,0-1.08-1.143A10.159,10.159,0,0,1,12.4,19.983,9.925,9.925,0,0,1,22.437,10.2a9.925,9.925,0,0,1,10.037,9.783c0,3.811-1.652,5.717-3.113,7.432a17.616,17.616,0,0,0-1.4,1.842,7.243,7.243,0,0,0-.826,3.875,1.025,1.025,0,0,1-.191.572C26.884,33.831,26.693,33.895,26.439,33.895Zm-7.051-1.461h6.289a7.744,7.744,0,0,1,1.08-4h0a23.216,23.216,0,0,1,1.525-1.969c1.4-1.652,2.732-3.24,2.732-6.48a8.58,8.58,0,0,0-17.152,0,8.814,8.814,0,0,0,3.176,7.051,6.5,6.5,0,0,1,1.27,1.4A7.6,7.6,0,0,1,19.388,32.434Z",
  transform: "translate(-12.4 -10.2)",
  fill: "#2a343f"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(15.18 31.911)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M29.35,50.725H22.3a.765.765,0,0,1,0-1.525H29.35a.772.772,0,0,1,.762.762A.734.734,0,0,1,29.35,50.725Z",
  transform: "translate(-21.6 -49.2)",
  fill: "#2a343f"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(16.832 34.261)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M28.647,54.425H24.9a.765.765,0,0,1,0-1.525h3.748a.772.772,0,0,1,.762.762A.734.734,0,0,1,28.647,54.425Z",
  transform: "translate(-24.2 -52.9)",
  fill: "#2a343f"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(18.801 1.8)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M28,5.866a.7.7,0,0,1-.7-.7V2.5a.7.7,0,0,1,1.4,0V5.1A.721.721,0,0,1,28,5.866Z",
  transform: "translate(-27.3 -1.8)",
  fill: "#2a343f"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(11.406 3.743)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.654,8.569a.7.7,0,0,1-.635-.381l-1.27-2.223a.741.741,0,1,1,1.27-.762l1.27,2.223a.8.8,0,0,1-.254,1.016A.467.467,0,0,1,17.654,8.569Z",
  transform: "translate(-15.659 -4.859)",
  fill: "#2a343f"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(5.992 9.192)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.1,16.208a.467.467,0,0,1-.381-.127l-2.223-1.27a.741.741,0,0,1,.762-1.27l2.223,1.27a.721.721,0,0,1,.254,1.016A.842.842,0,0,1,10.1,16.208Z",
  transform: "translate(-7.136 -13.436)",
  fill: "#2a343f"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(30.49 16.601)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M49.448,26.5H46.462a.763.763,0,0,1-.762-.7.721.721,0,0,1,.762-.7h2.986a.7.7,0,1,1,0,1.4Z",
  transform: "translate(-45.7 -25.1)",
  fill: "#2a343f"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(4 16.538)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.43,26.461H4.7a.7.7,0,0,1-.7-.7A.763.763,0,0,1,4.7,25H7.367a.734.734,0,0,1,.064,1.461Z",
  transform: "translate(-4 -25)",
  fill: "#2a343f"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(29.066 9.206)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M44.184,16.344a.7.7,0,0,1-.635-.381.779.779,0,0,1,.254-1.016l2.477-1.4a.741.741,0,1,1,.762,1.27l-2.477,1.4A.9.9,0,0,1,44.184,16.344Z",
  transform: "translate(-43.459 -13.459)",
  fill: "#2a343f"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(24.747 3.792)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M37.384,8.725A.467.467,0,0,1,37,8.6a.779.779,0,0,1-.254-1.016l1.4-2.287a.721.721,0,0,1,1.016-.254.779.779,0,0,1,.254,1.016l-1.334,2.35A1.02,1.02,0,0,1,37.384,8.725Z",
  transform: "translate(-36.659 -4.936)",
  fill: "#2a343f"
})));

function SvgIconMyEatingTipsGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 33.986,
    viewBox: "0 0 31 33.986",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMyEatingTipsGray);
export default __webpack_public_path__ + "static/media/icon-my-eating-tips-gray.2a294e61.svg";
export { ForwardRef as ReactComponent };